/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams} from 'ionic-angular';
import {LotteryPage} from "../lottery/lottery";
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AgentPEPage} from "../agentPE/agentPE";

@Component({
  templateUrl: 'agentPEList.html',
  selector: 'agent-p-e-list-page',
})
export class AgentPEListPage {
  private recordList: any = [];
  private infiniteScrollBoolean: boolean = true;
  private totalNum: number = 0;
  private requestData: any;

  constructor(private nav: NavController, public params: NavParams, private alertCtrl: AlertController,
              private userService: UserService, public viewCtrl: ViewController) {
    this.requestData = params.get("requestData");
    this.dealData(params.get("data"));
  }

  goDetail(index: string) {
    this.nav.push(AgentPEPage, {
      lname: index
    });
  }

  doRefresh(refresher) {
    this.getFirstData(refresher);
  }

  getFirstData(refresher: any = null) {
    let dataParams = {
      lotteryid: LotteryPage.lotteryId
    };
    this.userService.agentPEBeanSearch(dataParams, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.dealData(data);
      }
      if (refresher) {
        refresher.complete();
        this.infiniteScrollBoolean = true;
      }
    });
  }

  doInfinite(infiniteScroll) {
    let dataParams = {
      lotteryid: LotteryPage.lotteryId
    };
    infiniteScroll.enable(false);
    setTimeout(()=> {
      this.userService.agentPEBeanSearchNext(dataParams, this.alertCtrl).then(data=> {
        if (!data["msg"]) {
          this.dealData(data);
          infiniteScroll.complete();
          infiniteScroll.enable(true);
        } else {
          infiniteScroll.enable(true);
          this.infiniteScrollBoolean = false;
        }
      });
    }, 500);
  }

  dealData(data: any) {
    this.totalNum = data["totalrecord"];
    this.recordList = data["reslist"];
  }
}



// WEBPACK FOOTER //
// ./src/pages/agentPEList/agentPEList.ts